export default __webpack_public_path__ + "static/media/img02.c7e7f4eb.jpg";